import { createFileRoute } from '@tanstack/react-router';

import { SignsLayout } from '@/routes/_authenticated/_management/verkehrszeichen/$adminLevelId/-SignsLayout';

export const Route = createFileRoute('/_authenticated/_management/verkehrszeichen')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: () => <SignsLayout />,
});
